<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import Swal from "sweetalert2";
import ItemAPI from "@/services/items/itemsAPI";
import CheckModal from "@/components/CheckModal";
import DontExist from "@/components/company/components/DontExist";
import politicaAlcoholDrogasAPI from "../../../services/standards/politicaAlcoholDrogas/politicaAlcoholDrogasAPI";
/**
 * Form elements component
 */
export default {
  page: {
    title: "Política de No alcohol y drogas",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    DontExist,
  },
  data() {
    return {
      title: "Política de No alcohol y drogas",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Estilo de vida y entornos saludables",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id || null
            }/estilo-vida`,
        },
        {
          text: "Política de No alcohol y drogas",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id || null
            }/politica-alcohol-drogas`,
        },
        {
          text: "Editar",
          active: true,
        },
      ],

      lista: [],
      file: null,
      itemData: null,
      acta: null,

      politica: {
        file: "datos",
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      loading: true,
      submitted: false,
      nit: this.$store.getters["company/getCompany"].nit || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(55)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },


    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.politica.file)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/3.1.7/politica_alcohol_drogas/${this.$route.params.id}/${name}`;
        } else {
          url = `sst-prod/${this.nit}/3.1.7/politica_alcohol_drogas/${this.$route.params.id}/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.politica.file = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    getIdentification() {
      politicaAlcoholDrogasAPI
        .getShow(this.$route.params.id)
        .then((response) => {
          this.loading = false;
          this.politica = {
            file: response.data.file,
            companies_id: response.data.companies_id,
          };
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async update() {
      try {
        this.submitted = true
        this.loading = true
        let response = await this.uploadDocument();
        if (response) {
          politicaAlcoholDrogasAPI
            .update(this.$route.params.id, {
              file: this.politica.file,
              companies_id: this.politica.companies_id,
            })
            .then((response) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "¡Informacion actualizada con éxito!",
                  type: "success",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                this.$router.go(-1);
              }, 2000)
            });
        } else {
          this.loading = false
          setTimeout(() => {
            Swal.fire({
              title: "¡No se ha podido actualizar!",
              type: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            window.location.reload()
          }, 2000)
        }
      } catch (error) {
        console.log(error);
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },
  },

  mounted() {
    this.getIdentification();
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading && classificationID <= 4">
          <div class="card">
            <div class="card-body">
              <div class="row px-3">
                <div class="col-12 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>
              <hr />

              <form class="form-group" @submit.prevent="update">
                <div class="form-row pt-3">
                  <b-form-group class="col-md-12 px-2" label="Subir archivo" label-for="file">
                    <b-form-file :disabled="!allowAccess()" type="file" id="file" ref="file" name="file"
                      browse-text="Buscar" :placeholder="politica.file
                        ? getFile(politica.file)
                        : `Selecciona un archivo...`
                        " drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0 pt-2">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else-if="!loading && classificationID > 3">
          <DontExist />
        </div>

        <div v-else-if="!loading">
          <DontExist />
        </div>
        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
